import React from 'react';
import { Box, Typography, styled } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import { PageContainer } from '../../sharedComponents/StyledComponents';

const Container = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: 'calc(100vh - 200px)',
  padding: theme.spacing(4),
  textAlign: 'center',
  gap: theme.spacing(3),
}));

const ErrorCode = styled(Typography)(({ theme }) => ({
  fontSize: '8rem',
  fontWeight: 700,
  lineHeight: 1,
  color: theme.palette.primary.main,
  marginBottom: theme.spacing(2),
  [theme.breakpoints.down('sm')]: {
    fontSize: '5rem',
  },
}));

const Title = styled(Typography)(({ theme }) => ({
  fontSize: '2rem',
  fontWeight: 600,
  color: theme.palette.text.primary,
  marginBottom: theme.spacing(1),
  [theme.breakpoints.down('sm')]: {
    fontSize: '1.5rem',
  },
}));

const Description = styled(Typography)(({ theme }) => ({
  fontSize: '1rem',
  color: theme.palette.text.secondary,
  maxWidth: '500px',
  lineHeight: 1.6,
}));

export const NotFoundPage: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>404 - Page Not Found</title>
        <meta name="description" content="Page not found" />
      </Helmet>
      <PageContainer>
        <Container>
          <ErrorCode>404</ErrorCode>
          <Title>Page Not Found</Title>
          <Description>
            The page you're looking for doesn't exist or has been moved. 
            Please check the URL or return to the homepage.
          </Description>
        </Container>
      </PageContainer>
    </>
  );
};

